<script>
  import Xbutton from 'commons/Xbutton.vue'
  import XcheckBox from 'commons/XcheckBox.vue'
  import Xspan from 'commons/Xspan.vue'
  import Vue from 'vue'
  export default {
    components: { Xbutton, XcheckBox, Xspan},
    name: 'TableCell',
    props: {
      category:{
        type: String,
        default: ''
      },
      cellConfig: {
        type: Array,
        default: ()=>[]
      },
      cellString: {
        type: String,
      },
      stringBefore: {
        type: Boolean,
        default: false
      },
      index: {
        type: Number,
        default: 0
      },
      cellIndex: {
        type: Number
      }
    },
    render(h){
      let ret
      //字符串的情况
      if( this.cellConfig.length === 0 ) {
        if( this.cellString != undefined) {
          ret  = this.cellString.length > 0?this.cellString:'无'
        }
      }else {
        //按钮的情况
        ret = this.cellConfig.map(item => {
          let option = item.optionStyle? item.optionStyle : {padding: '0 .6rem'}
          if(this.category === 'XcheckBox') {
            return h(
              XcheckBox,
              {
                props:{
                  check:item.check,
                  name:item.name,
                },
                on:{XcheckService:this.XcheckService}
              }
            )
          }else if(this.category === 'Xspan') {
            return h(
              Xspan,
              {
                props:{
                  font:item.font,
                  type:item.type,
                }
              }
            )
          } else {
            return h(
              Xbutton,
              {
                class:'z-margin-h-75-precent',
                props:{
                  font:item.font,
                  type:item.type,
                  optionStyle: option
                },
                on:{XbuttonService:this.XbuttonService}
              },
              [
                h('i',{
                  class:'z-color-fff iconfont ' + item.iconCls,
                  slot:'before',
                  style: 'font-size: 2.6rem;'
                })
              ]
            )
          }

        })
        //字符串加按钮的情况
        if( this.cellString != undefined ) {
          let temp = this.cellIndex === 0&&this.cellString.length > 10? this.cellString.substr(0,10) + '..' : this.cellString
          if( this.stringBefore ) ret.unshift(h('span',{},temp))
          else ret.push(h('span',temp))
        }
        //为空的情况
        if( this.cellConfig.length === 0 && this.cellString == undefined ) {
          ret = '无'
        }
      }
      if( this.cellIndex === 0 && this.cellConfig.length > 0) return h('span',{class:'ub-box ub-ver'},ret)
      return h('span',{class:'ub-box ub-ver'},ret)
    },
    methods: {
      XbuttonService (type) {
        this.$emit('XbuttonService', type, this.index)
      },
      XcheckService(flag){
        this.$emit('XcheckService', flag, this.index)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/commons/Xcell.vue